import create from 'zustand';
import { persist } from 'zustand/middleware';
import { UserViewState } from './interfaces/UserViewState';
import { STANDARD_VIEW_ID } from 'components/ManageQueries/Filters/StandardView';

export const useUserViewStore = create(
  persist<UserViewState>(
    (set) => ({
      views: [],
      sessionVariant: undefined,
      shouldUseSessionVariant: false,
      dirtyState: false,
      defaultViewPreferenceId: STANDARD_VIEW_ID,
      setSessionVariant: (value) => set(() => ({ sessionVariant: value })),
      setShouldUseSessionVariant: (value) => set(() => ({ shouldUseSessionVariant: value })),
      setDirtyState: (value) => set(() => ({ dirtyState: value })),
      setDefaultViewPreferenceId: (value) => set(() => ({ defaultViewPreferenceId: value })),
      setViews: (value) => set(() => ({ views: value }))
    }),
    {
      name: 'user-view'
    }
  )
);
